import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { useRemoveExternalSchedule } from '@services/schedules/remove';
import { useCompleteTask } from '@services/tasks/complete';
import { useRevertTask } from '@services/tasks/revert';
import { useTranslation } from 'react-i18next';
import { ExternalScheduleActionsProps } from './types';
import { cn } from '@utils/cn';

export const ExternalScheduleActions = ({
  setOpen,
  locked,
  completed,
  jobId,
  taskId: id,
  scheduleId,
  concreteDirectId,
}: ExternalScheduleActionsProps) => {
  const { t } = useTranslation('app');

  const complete = useCompleteTask();
  const revert = useRevertTask();

  const remove = useRemoveExternalSchedule({
    id: scheduleId || '',
    jobId: jobId || '',
    taskId: id,
  });

  const handleRemove = () => {
    setOpen(false);
    remove.mutate();
  };

  const handleAction = () => {
    if (!id || !jobId) return;
    if (completed) revert.mutate({ id, jobId });
    else {
      complete.mutate({ id, jobId });
      setOpen(false);
    }
  };

  const disabled = complete.isLoading || revert.isLoading || remove.isLoading || locked;

  return (
    <div className={cn('flex items-center gap-2', !id ? 'justify-end' : 'justify-between')}>
      {id && (
        <Button
          variant={completed ? 'successSecondary' : 'secondary'}
          disabled={(!scheduleId && !completed) || disabled || Boolean(concreteDirectId)}
          onClick={handleAction}>
          <SvgConsumer id="markAsDone" className="text-xl" />
          {completed ? t('actions.done') : t('actions.markAsDone')}
        </Button>
      )}
      <div className="flex items-center justify-end gap-2">
        <Button variant="secondary" onClick={() => setOpen(false)}>
          {t('actions.cancel')}
        </Button>
        {scheduleId && (
          <Button
            disabled={!scheduleId || completed || disabled}
            variant="dangerSecondary"
            onClick={handleRemove}>
            {t('actions.removeSchedule')}
          </Button>
        )}
        <Button
          variant="default"
          type="submit"
          disabled={completed || disabled || (Boolean(scheduleId) && Boolean(concreteDirectId))}>
          {t('actions.save')}
        </Button>
      </div>
    </div>
  );
};
